export default (n)=>{
    return n.toFixed(2)
}